<template>
  <div>
    <div class="live_input" v-if="showSubmit == 1">
      <div @click="submitComment()" class="live_input_content"> 写点评论吧..</div>
    </div>
  </div>
</template>

<script>
  const _userAgent = window.navigator.userAgent
  export default {
    name: 'CommentBox',
    props: ['topicInfo', 'sid', 'discussID'],
    data () {
      return {
        showSubmit: 0
      }
    },
    methods: {
      submitComment () {
        window.location.href = 'writetopiccomment:///?discussID=' + this.discussID + '&title=' + encodeURIComponent(this.topicInfo.title)
      }
    },
    mounted () {
      try {
        if (_userAgent.indexOf('xkyApp') > -1) {
          try {
            let str = this.topicInfo.endTime
            str = str && (str + '').replace(/-/g, '/')
            // eslint-disable-next-line eqeqeq
            this.showSubmit = (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') && (new Date(str).getTime() - new Date().getTime() > 0) || 0
          } catch (e) {
            console.log(e)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    watch: {
      topicInfo (newValue, oldValue) {
        try {
          if (_userAgent.indexOf('xkyApp') > -1) {
            try {
              let str = this.topicInfo.endTime
              str = str && (str + '').replace(/-/g, '/')
              // eslint-disable-next-line eqeqeq
              this.showSubmit = (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') && (new Date(str).getTime() - new Date().getTime() > 0) || 0
            } catch (e) {
              console.log(e)
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>

<style scoped>
  .live_input {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 999;
    background: #fff;
    border-top: 1px solid #EEEEEE;
    padding: 10px 15px;
    font-size: 15px;
  }

  .live_input .live_input_content {
    width: 100%;
    border: none;
    background: rgb(239, 239, 239);
    padding: 10px 20px;
    border-radius: 100px;
    outline: none;
    font-size: 14px;
    height: auto;
    float: none;
    margin: 0 !important;
    line-height: 16px;
    color: #999999;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

</style>



// WEBPACK FOOTER //
// CommentBox.vue?1e7ae7fc